// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"ShkWcYQ","inner":"FqNkrA8","touch":"fQh1nOE","header":"NE1RNmt"};